import { getScreenNameAuthenticated } from "../../utils/auth/Auth-utils";
import * as FuncionesServices from "../../utils/funciones-services";

export const getCotizaciones = async (idProspecto) => {
    let atributos = [{ campo: 'idProspecto', valor: idProspecto }]
    return FuncionesServices.manejarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_COTIZACIONES, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Transaccion-Id'            : FuncionesServices.generarTransaccionId(),
            'Nombre-Servicio-Consumidor': process.env.REACT_APP_NOMBRE_SERVICIO_CONSUMIDOR,
            'Nombre-Aplicacion'         : process.env.REACT_APP_NOMBRE_APLICACION,
            'Usuario-Consumidor-Id'     : getScreenNameAuthenticated(),
            'Aplicacion-Id'             : process.env.REACT_APP_APLICACION_ID
        })
    })
}

export const getDetalleCotizacion = (idProspecto, codigoCotizacion) => {
    let atributos = [
        { campo: 'idProspecto', valor: idProspecto },
        { campo: 'codigoCotizacion', valor: codigoCotizacion },
    ]
    return FuncionesServices.manejarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_PROSPECTO_X_CODIGO_COTIZACION, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Transaccion-Id'            : FuncionesServices.generarTransaccionId(),
            'Nombre-Servicio-Consumidor': process.env.REACT_APP_NOMBRE_SERVICIO_CONSUMIDOR,
            'Nombre-Aplicacion'         : process.env.REACT_APP_NOMBRE_APLICACION,
            'Usuario-Consumidor-Id'     : getScreenNameAuthenticated(),
            'Aplicacion-Id'             : process.env.REACT_APP_APLICACION_ID
        })
    })
}